import type { SVGProps } from 'react'

export function GooglePayIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      {...props}
    >
      <path d="M11.794 10.508V13.2h1.816c-.154.834-.984 2.444-1.816 2.444-1.098 0-1.994-.91-1.994-2.034s.896-2.034 1.994-2.034c.624 0 1.044.266 1.282.496l.876-.844c-.56-.524-1.29-.85-2.158-.85-1.792 0-3.248 1.456-3.248 3.248s1.456 3.248 3.248 3.248c1.876 0 3.12-1.32 3.12-3.178 0-.214-.022-.376-.05-.54h-3.07zm4.88.056v.896h.896v.896h-.896v.896h-.896v-.896h-.896v-.896h.896v-.896h.896zm2.68 0v.896h.896v.896h-.896v.896h-.896v-.896h-.896v-.896h.896v-.896h.896z" />
    </svg>
  )
}
